/* eslint-disable
    prefer-rest-params
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS103: Rewrite code to no longer use __guard__
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import ExternalFile from 'external-files/ExternalFile';
import * as ExternalFileTab from 'external-files/ExternalFileTab';

const {ExternalFileTabView, ExternalFileOptionsView} = ExternalFileTab;

import BaseEntryProtocolTabState from 'notebook/entries/backbone/tabs/BaseEntryProtocolTab';

class ExternalEntryProtocolTabState extends BaseEntryProtocolTabState {
  // also implements ExternalFileTabState
  initialize() {
    super.initialize(...arguments);
    // Keep the external file backbone model in sync with the store.
    // Note: the view should use update handlers instead of directly manipulating the externalFile.
    this.set({
      externalFile: new ExternalFile(this.protocol().externalFile),
      owningEntityApiId: this.file().id,
    });
    this.listenTo(this.file(), 'change', this.syncFromStore);
    this.on('change:protocolCid', this.syncFromStore);
  }

  externalFile() {
    return this.get('externalFile');
  }
  previewFile() {
    return null;
  }
  owningEntityApiId() {
    return this.get('owningEntityApiId');
  }
  updateName(name) {
    this.updateProtocol({$merge: {name}});
  }

  updatePreviewType(previewType) {
    this.updateProtocol({externalFile: {$merge: {previewType}}});
  }

  syncFromStore() {
    this.externalFile().set(__guard__(this.protocol(), (x) => x.externalFile));
  }
}

export {
  ExternalFileTabView as ExternalEntryProtocolTabView,
  ExternalEntryProtocolTabState,
  ExternalFileOptionsView as ExternalEntryProtocolOptionsView,
};

function __guard__(value, transform) {
  return value != null ? transform(value) : undefined;
}
